import i18next from "i18next";
import React, { useMemo, useRef } from "react";
import { CommonButton, FormElementWrapper, FormWrapper, TextInput, Upload } from "../../../components";
import * as yup from "yup";

const validation = (title) => {
  return yup.object().shape({
    [title]: yup.string().nullable().required(i18next.t('text.equipmentInstall.receiptRequired')),
    ...(title === "warrantyCertificate" && {
      warrantyTitle: yup.string().nullable().required(i18next.t('text.equipmentInstall.receiptRequired')),
    }),
  });
};

// Memoized Upload field: only re-renders when "name" or "value" changes
const UploadField = React.memo(function UploadField({ name, value, uploadRef }) {
  return (
    <Upload
      name={name}
      mediaFor={name}
      isAllDoc
      publicUpload
      type="doc"
      mediaType="doc"
      allowedFormat={["doc", "image"]}
      successMsg={i18next.t("text.common.documentUploadedSuccess")}
      imageUrlList={value ? [value] : ""}
      isCrop={false}
      isDrag
      removePreview
      ref={uploadRef}
    />
  );
}, (prev, next) => prev.name === next.name && prev.value === next.value);

export default function UploadWarrantyReceipt({ receiptData, onSubmit, title }) {
  const uploadRef1 = useRef();
  const fieldName = title || "warrantyCertificate";

  // Prefill once; enableReinitialize will only run when these change
  const initialValues = useMemo(() => ({
    title: receiptData?.getWarrantyCertificateUrl || "",
    warrantyTitle: receiptData?.id === "warranty" ? (receiptData?.title || "") : "",
    [fieldName]: receiptData?.getCertificateUrl || ""
  }), [
    receiptData?.getWarrantyCertificateUrl,
    receiptData?.getCertificateUrl,
    receiptData?.id,
    receiptData?.title,
    fieldName
  ]);

  return (
    <FormWrapper
      row
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize={true}
      data={initialValues}
      validation={() => validation(fieldName)}
    >
      {(props) => (
        <>
          {receiptData?.id === "warranty" && (
            <FormElementWrapper
              md={12}
              lg={12}
              mandatory
              label={i18next.t("text.equipmentInstall.certificateTitle")}
              element={() => (
                <>
                  <TextInput
                    type="text"
                    name="warrantyTitle"
                    className="form-control m-2"
                    value={props.values.warrantyTitle}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                  />
                  <br />
                </>
              )}
            />
          )}

          <FormElementWrapper
            md={12}
            lg={12}
            mandatory
            label={
              fieldName === "ahriCertificateUrl"
                ? i18next.t("text.equipmentInstall.ahriWarrantyReceiptUpload")
                : fieldName === "warrantyPaperCertificateUrl"
                ? i18next.t("text.equipmentInstall.warrantyPaperReceiptUpload")
                : i18next.t("text.equipmentInstall.warrantyReceiptUpload")
            }
            element={() => (
              // <UploadField
              //   name={fieldName}
              //   value={props.values[fieldName]}   {/* Only this value drives Upload re-render */}
              //   uploadRef={uploadRef1}
              // />
              <UploadField
                name={fieldName}
                value={props.values[fieldName]}
                uploadRef={uploadRef1}
              />
            )}
          />

          <div className="mt-4 text-end">
            <CommonButton type="submit" className="btn btn-primary">
              {i18next.t("text.common.submit")}
            </CommonButton>
          </div>
        </>
      )}
    </FormWrapper>
  );
}
